module.exports = __webpack_public_path__ + "img/Hsj.9dc2179d.png";